import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import api from "../Services/api";
import apiComunicacao from "../Services/apiComunicacao";
import { app_base_url, app_server } from "../Utils/baseUrl";
import {
  funcionarioPrefeituraKey,
  funcionarioPrefeituraTokenKey,
} from "../Utils/localStorageKeys";
import { useCartorio } from "./cartorio";
import { usePrefeitura } from "./usePrefeitura";

export interface IFuncionarioPrefeitura {
  ID: number;
  NOME: string;
  CPF: string;
  EMAIL: string;
  FONE: string;
  WHATS: string;
  SENHA: string;
  PREFEITURA_ID: number;
  ATIVO: "A" | "I";
  AVALIAR: "S" | "N";
}
export interface IFuncionarioPrefeituraList {
  ENTIDADE: string;
  ID: 14;
  NOME: string;
  CPF: string;
  EMAIL: string;
  FONE: string;
  WHATS: string;
  ATIVO: string;
  PREFEITURA_ID?: number;
  CARTORIO_ID?: number;
}

interface IFuncionarioPrefeituraContextData {
  getfuncionariosPrefeitura(prefeituraId: number): Promise<void>;
  funcionariosPrefeitura: IFuncionarioPrefeitura[];
  addCartoroFuncionarioPrefeitura(funcionario: IFuncionarioPrefeitura): void;
  atualizaFuncionarioPrefeitura(funcionario: IFuncionarioPrefeitura): void;
  SignInFuncionarioPrefeitura(id: number, senha: string): Promise<void>;
  FuncionarioPrefeitura: IFuncionarioPrefeitura;
  funcionarioPrefeituraIsLogged: boolean;
  handleSetFuncionarioPrefeitura(param: IFuncionarioPrefeitura): void;
  signOutFuncionarioPrefeitura(): void;
  checarTokenFuncionarioPrefeitura(): Promise<void>;
  helpSignInHashFuncionarioPrefeitura(): void;
}

interface IFuncionarioPrefeituraProviderProps {
  children: ReactNode;
}

const FuncionarioPrefeituraContext = createContext(
  {} as IFuncionarioPrefeituraContextData
);

function FuncionarioPrefeituraProvider({
  children,
}: IFuncionarioPrefeituraProviderProps) {
  const { getPrefeituraById } = usePrefeitura();
  const [funcionariosPrefeitura, setfuncionariosPrefeitura] = useState(
    {} as IFuncionarioPrefeitura[]
  );

  const [FuncionarioPrefeitura, setFuncionarioPrefeitura] = useState(
    {} as IFuncionarioPrefeitura
  );
  const { getCartorio } = useCartorio();
  useEffect(() => {
    checarTokenFuncionarioPrefeitura();
    //if (FuncionarioPrefeitura.ID) getCartorio(FuncionarioPrefeitura.pREF);
  }, [FuncionarioPrefeitura.ID]);
  const [
    funcionarioPrefeituraIsLogged,
    setfuncionarioPrefeituraIsLogged,
  ] = useState(false);

  async function SignInFuncionarioPrefeitura(id: number, senha: string) {
    try {
      const { data } = await api.post(`/funcionario-prefeitura/signIn`, {
        id,
        senha,
      });
      localStorage.setItem(
        funcionarioPrefeituraKey,
        JSON.stringify(data.funcionario)
      );
      localStorage.setItem(funcionarioPrefeituraTokenKey, data.token);
      api.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
      setFuncionarioPrefeitura(data.funcionario);
      setfuncionarioPrefeituraIsLogged(true);
    } catch (error) {
      throw error;
    }
  }

  async function checarTokenFuncionarioPrefeitura() {
    try {
      const token = localStorage.getItem(funcionarioPrefeituraTokenKey);
      const getCartorio = localStorage.getItem(funcionarioPrefeituraKey);
      if (token && getCartorio) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        await api.get("/checa-token");
        setFuncionarioPrefeitura(JSON.parse(getCartorio));
        setfuncionarioPrefeituraIsLogged(true);
      }
    } catch (error) {
      //Se estiver invalido o token eu valido ele
      if (FuncionarioPrefeitura) {
        await signInSenhaHash();
      }else{
        signOutFuncionarioPrefeitura();
        throw "Token Inválido!";
      }
     
    }
  }

  async function signOutFuncionarioPrefeitura() {
    try {
      localStorage.removeItem(funcionarioPrefeituraKey);
      localStorage.removeItem(funcionarioPrefeituraTokenKey);

      setFuncionarioPrefeitura({} as IFuncionarioPrefeitura);
      setfuncionarioPrefeituraIsLogged(false);
      window.location.href = `${app_server}${app_base_url}/prefeitura/funcionario`;
    } catch (error) {
      throw error;
    }
  }

  function handleSetFuncionarioPrefeitura(param: IFuncionarioPrefeitura) {
    setFuncionarioPrefeitura(param);
    localStorage.setItem(funcionarioPrefeituraKey, JSON.stringify(param));
  }

  useEffect(() => {
    if (FuncionarioPrefeitura.PREFEITURA_ID) {
      getPrefeituraById(FuncionarioPrefeitura.PREFEITURA_ID);
    }
  }, [FuncionarioPrefeitura.ID]);

  async function signInSenhaHash() {
    const getFuncionario = localStorage.getItem(funcionarioPrefeituraKey);
    if (getFuncionario != null) {
      setFuncionarioPrefeitura(JSON.parse(getFuncionario));
      if (FuncionarioPrefeitura) {
        //window.alert(FuncionarioPrefeitura.ID + " " +FuncionarioPrefeitura.SENHA )
        try {
          const { data } = await api.post(`/funcionario-cartorio/signInHash`, {
            id: FuncionarioPrefeitura.ID,
            senha: FuncionarioPrefeitura.SENHA,
          });
          api.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
          apiComunicacao.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
          setFuncionarioPrefeitura(data.funcionario);
          setfuncionarioPrefeituraIsLogged(true);
        } catch (error) {
          signOutFuncionarioPrefeitura();
          throw error;
        }
      }
    }
  }

  async function getfuncionariosPrefeitura(prefeituraId: number) {
    try {
      const { data } = await api.get(`/funcionario-prefeitura/${prefeituraId}`);
      setfuncionariosPrefeitura(data);
    } catch (error) {
      throw error;
    }
  }

  function addCartoroFuncionarioPrefeitura(
    funcionario: IFuncionarioPrefeitura
  ) {
    setfuncionariosPrefeitura((prevState) => [...prevState, funcionario]);
  }

  function atualizaFuncionarioPrefeitura(funcionario: IFuncionarioPrefeitura) {
    setfuncionariosPrefeitura(
      funcionariosPrefeitura.map((item) => {
        if (item.ID == funcionario.ID) {
          return funcionario;
        }

        return item;
      })
    );
  }

  function helpSignInHashFuncionarioPrefeitura(){
    signInSenhaHash();
  }

  return (
    <FuncionarioPrefeituraContext.Provider
      value={{
        helpSignInHashFuncionarioPrefeitura,
        getfuncionariosPrefeitura,
        funcionariosPrefeitura,
        addCartoroFuncionarioPrefeitura,
        atualizaFuncionarioPrefeitura,
        FuncionarioPrefeitura,
        funcionarioPrefeituraIsLogged,
        SignInFuncionarioPrefeitura,
        handleSetFuncionarioPrefeitura,
        signOutFuncionarioPrefeitura,
        checarTokenFuncionarioPrefeitura,
      }}
    >
      {children}
    </FuncionarioPrefeituraContext.Provider>
  );
}

function useFuncionarioPrefeitura() {
  const context = useContext(FuncionarioPrefeituraContext);

  return context;
}

export { FuncionarioPrefeituraProvider, useFuncionarioPrefeitura };
